module.exports = __webpack_public_path__ + "static/media/sonamar.2dc754b8.jpg";